<template>
    <div class="row" v-if="id">
        <div class="col" v-for="step in steps" v-bind:key="step">
            <button class="btn w-100 text-truncate text-capitalize" :class="step == this.currentStep ? 'bg-gradient-primary text-white' : 'bg-white'" @click="changeStep(step)">{{ step.replaceAll('_', ' ') }}</button>
        </div>
    </div>
    <form @submit.prevent="Store">
        <template v-if="currentStep == 'permohonan'">
            <div class="card card-body shadow mb-3" v-if="this.id">
                <div class="form-group">
                    <label>Nomor Surat</label>
                    <input type="text" name="permohonan_nomor_surat" class="form-control" :class="this.errors.permohonan_nomor_surat ? 'is-invalid' : ''" v-model="this.data.permohonan_nomor_surat">
                    <div class="invalid-feedback">{{ errors.permohonan_nomor_surat }}</div>
                </div>
                <div class="form-group">
                    <label>Tanggal Surat</label>
                    <input type="date" name="permohonan_tanggal_surat" class="form-control" :class="this.errors.permohonan_tanggal_surat ? 'is-invalid' : ''" v-model="this.data.permohonan_tanggal_surat">
                    <div class="invalid-feedback">{{ errors.permohonan_tanggal_surat }}</div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-header text-white bg-gradient-primary fw-bold">
                    Permohonan Pemakaian Kekayaan Daerah Kendaraan / Alat Berat
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Nama</label>
                        <input type="text" name="permohonan_nama" class="form-control" :class="this.errors.permohonan_nama ? 'is-invalid' : ''" v-model="this.data.permohonan_nama">
                        <div class="invalid-feedback">{{ errors.permohonan_nama }}</div>
                    </div>
                    <div class="form-group">
                        <label>Bertindak Atas Nama</label>
                        <input type="text" name="permohonan_bertindak_atas_nama" class="form-control" :class="this.errors.permohonan_bertindak_atas_nama ? 'is-invalid' : ''" v-model="this.data.permohonan_bertindak_atas_nama">
                        <div class="invalid-feedback">{{ errors.permohonan_bertindak_atas_nama }}</div>
                    </div>
                    <div class="form-group">
                        <label>Pekerjaan</label>
                        <input type="text" name="permohonan_pekerjaan" class="form-control" :class="this.errors.permohonan_pekerjaan ? 'is-invalid' : ''" v-model="this.data.permohonan_pekerjaan">
                        <div class="invalid-feedback">{{ errors.permohonan_pekerjaan }}</div>
                    </div>
                    <div class="form-group">
                        <label>Alamat</label>
                        <input type="text" name="permohonan_alamat" class="form-control" :class="this.errors.permohonan_alamat ? 'is-invalid' : ''" v-model="this.data.permohonan_alamat">
                        <div class="invalid-feedback">{{ errors.permohonan_alamat }}</div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-header text-white bg-gradient-primary fw-bold">
                    Bahwa berdasarkan uraian pekerjaan sebagaimana tersebut di bawah ini :
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Nomor SPK</label>
                        <input type="text" name="permohonan_nomor_spk" class="form-control" :class="this.errors.permohonan_nomor_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_nomor_spk">
                        <div class="invalid-feedback">{{ errors.permohonan_nomor_spk }}</div>
                    </div>
                    <div class="form-group">
                        <label>Tanggal SPK</label>
                        <input type="date" name="permohonan_tanggal_spk" class="form-control" :class="this.errors.permohonan_tanggal_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_tanggal_spk">
                        <div class="invalid-feedback">{{ errors.permohonan_tanggal_spk }}</div>
                    </div>
                    <div class="form-group">
                        <label>Nama Pekerjaan</label>
                        <input type="text" name="permohonan_nama_pekerjaan_spk" class="form-control" :class="this.errors.permohonan_nama_pekerjaan_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_nama_pekerjaan_spk">
                        <div class="invalid-feedback">{{ errors.permohonan_nama_pekerjaan_spk }}</div>
                    </div>
                    <div class="form-group">
                        <label>Lokasi Pekerjaan</label>
                        <div class="row">
                            <div class="col-4">
                                <input type="text" name="permohonan_desa_pekerjaan_spk" class="form-control" placeholder="Desa" :class="this.errors.permohonan_desa_pekerjaan_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_desa_pekerjaan_spk">
                                <div class="invalid-feedback">{{ errors.permohonan_desa_pekerjaan_spk }}</div>
                            </div>
                            <div class="col-4">
                                <input type="text" name="permohonan_kecamatan_pekerjaan_spk" class="form-control" placeholder="Kecamatan" :class="this.errors.permohonan_kecamatan_pekerjaan_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_kecamatan_pekerjaan_spk">
                                <div class="invalid-feedback">{{ errors.permohonan_kecamatan_pekerjaan_spk }}</div>
                            </div>
                            <div class="col-4">
                                <input type="text" name="permohonan_kabupaten_pekerjaan_spk" class="form-control" placeholder="Kabupaten/Kota" :class="this.errors.permohonan_kabupaten_pekerjaan_spk ? 'is-invalid' : ''" v-model="this.data.permohonan_kabupaten_pekerjaan_spk">
                                <div class="invalid-feedback">{{ errors.permohonan_kabupaten_pekerjaan_spk }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-header text-white bg-gradient-primary fw-bold">
                    Dengan ini mengajukan permohonan izin pemakaian kekayaan daerah, berupa :
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-9">
                            <label>Alat Berat</label>
                            <select class="form-select" name="permohonan_alat_berat_id" :class="this.errors.permohonan_alat_berat_id ? 'is-invalid' : ''" v-model="this.data.permohonan_alat_berat_id">
                                <option value="" selected hidden disabled>Pilih Alat Berat</option>
                                <option :value="alatBerat.id" v-for="alatBerat in this.alatBerats" v-bind:key="alatBerat">{{ alatBerat.nama }}</option>
                            </select>
                            <div class="invalid-feedback">{{ errors.permohonan_alat_berat_id }}</div>
                        </div>
                        <div class="form-group col-3">
                            <label>Jumlah</label>
                            <input type="number" name="permohonan_alat_berat_jumlah" class="form-control" :class="this.errors.permohonan_alat_berat_jumlah ? 'is-invalid' : ''" v-model="this.data.permohonan_alat_berat_jumlah">
                            <div class="invalid-feedback">{{ errors.permohonan_alat_berat_jumlah }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <label>Tanggal Peminjaman</label>
                            <input type="date" name="permohonan_terhitung_mulai_tanggal" class="form-control" :class="this.errors.permohonan_terhitung_mulai_tanggal ? 'is-invalid' : ''" v-model="this.data.permohonan_terhitung_mulai_tanggal">
                            <div class="invalid-feedback">{{ errors.permohonan_terhitung_mulai_tanggal }}</div>
                        </div>
                        <div class="form-group col">
                            <label>Tanggal Pengembalian</label>
                            <input type="date" name="permohonan_pengembalian_tanggal" class="form-control" :class="this.errors.permohonan_pengembalian_tanggal ? 'is-invalid' : ''" v-model="this.data.permohonan_pengembalian_tanggal">
                            <div class="invalid-feedback">{{ errors.permohonan_pengembalian_tanggal }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 'ijin_pemakaian'">
            <div class="card card-body shadow mb-3">
                <div class="form-group">
                    <label>Nomor Surat</label>
                    <input type="text" name="surat_izin_nomor_surat" class="form-control" :class="this.errors.surat_izin_nomor_surat ? 'is-invalid' : ''" v-model="this.data.surat_izin_nomor_surat">
                    <div class="invalid-feedback">{{ errors.surat_izin_nomor_surat }}</div>
                </div>
                <div class="form-group">
                    <label>Tanggal Surat</label>
                    <input type="date" name="surat_izin_tanggal_surat" class="form-control" :class="this.errors.surat_izin_tanggal_surat ? 'is-invalid' : ''" v-model="this.data.surat_izin_tanggal_surat">
                    <div class="invalid-feedback">{{ errors.surat_izin_tanggal_surat }}</div>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 'perjanjian_sewa'">
            <div class="card card-body shadow mb-3">
                <div class="form-group">
                    <label>Nomor Surat</label>
                    <input type="text" name="perjanjian_nomor_surat" class="form-control" :class="this.errors.perjanjian_nomor_surat ? 'is-invalid' : ''" v-model="this.data.perjanjian_nomor_surat">
                    <div class="invalid-feedback">{{ errors.perjanjian_nomor_surat }}</div>
                </div>
                <div class="form-group">
                    <label>Tanggal Surat</label>
                    <input type="date" name="perjanjian_tanggal_surat" class="form-control" :class="this.errors.perjanjian_tanggal_surat ? 'is-invalid' : ''" v-model="this.data.perjanjian_tanggal_surat">
                    <div class="invalid-feedback">{{ errors.perjanjian_tanggal_surat }}</div>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 'pengambilan_alat_berat'">
            <div class="card card-body shadow mb-3">
                <div class="form-group">
                    <label>Nomor Surat</label>
                    <input type="text" name="pengambilan_nomor_surat" class="form-control" :class="this.errors.pengambilan_nomor_surat ? 'is-invalid' : ''" v-model="this.data.pengambilan_nomor_surat">
                    <div class="invalid-feedback">{{ errors.pengambilan_nomor_surat }}</div>
                </div>
                <div class="form-group">
                    <label>Tanggal Surat</label>
                    <input type="date" name="pengambilan_tanggal_surat" class="form-control" :class="this.errors.pengambilan_tanggal_surat ? 'is-invalid' : ''" v-model="this.data.pengambilan_tanggal_surat">
                    <div class="invalid-feedback">{{ errors.pengambilan_tanggal_surat }}</div>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 'pengembalian_alat_berat'">
            <div class="card card-body shadow mb-3">
                <div class="form-group">
                    <label>Nomor Surat</label>
                    <input type="text" name="pengembalian_nomor_surat" class="form-control" :class="this.errors.pengembalian_nomor_surat ? 'is-invalid' : ''" v-model="this.data.pengembalian_nomor_surat">
                    <div class="invalid-feedback">{{ errors.pengembalian_nomor_surat }}</div>
                </div>
                <div class="form-group">
                    <label>Tanggal Surat</label>
                    <input type="date" name="pengembalian_tanggal_surat" class="form-control" :class="this.errors.pengembalian_tanggal_surat ? 'is-invalid' : ''" v-model="this.data.pengembalian_tanggal_surat">
                    <div class="invalid-feedback">{{ errors.pengembalian_tanggal_surat }}</div>
                </div>
            </div>
        </template>
        <template v-if="currentStep == 'pemeriksaan_alat_berat'">
            <div class="card shadow mb-3" v-for="jenis in ['pengambilan', 'pengembalian']" v-bind:key="jenis">
                <div class="card-header bg-primary">
                    <h3 class="text-white text-capitalize">Pemeriksaan {{ jenis }}</h3>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Nomor Surat</label>
                        <input type="text" :name="'pemeriksaan_' + jenis + '_nomor_surat'" class="form-control" :class="this.errors['pemeriksaan_' + jenis + '_nomor_surat'] ? 'is-invalid' : ''" v-model="this.data['pemeriksaan_' + jenis + '_nomor_surat']">
                        <div class="invalid-feedback">{{ errors['pemeriksaan_' + jenis + '_nomor_surat'] }}</div>
                    </div>
                    <div class="form-group">
                        <label>Tanggal Surat</label>
                        <input type="date" :name="'pemeriksaan_' + jenis + '_tanggal_surat'" class="form-control" :class="this.errors['pemeriksaan_' + jenis + '_tanggal_surat'] ? 'is-invalid' : ''" v-model="this.data['pemeriksaan_' + jenis + '_tanggal_surat']">
                        <div class="invalid-feedback">{{ errors['pemeriksaan_' + jenis + '_tanggal_surat'] }}</div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label>Nama Pemeriksa</label>
                                <input type="text" :name="'pemeriksaan_' + jenis + '_pemeriksa_nama'" class="form-control" :class="this.errors['pemeriksaan_' + jenis + '_pemeriksa_nama'] ? 'is-invalid' : ''" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksa_nama']">
                                <div class="invalid-feedback">{{ errors['pemeriksaan_' + jenis + '_pemeriksa_nama'] }}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label>NIP Pemeriksa</label>
                                <input type="text" :name="'pemeriksaan_' + jenis + '_pemeriksa_nip'" class="form-control" :class="this.errors['pemeriksaan_' + jenis + '_pemeriksa_nip'] ? 'is-invalid' : ''" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksa_nip']">
                                <div class="invalid-feedback">{{ errors['pemeriksaan_' + jenis + '_pemeriksa_nip'] }}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label>Jabatan Pemeriksa</label>
                                <input type="text" :name="'pemeriksaan_' + jenis + '_pemeriksa_jabatan'" class="form-control" :class="this.errors['pemeriksaan_' + jenis + '_pemeriksa_jabatan'] ? 'is-invalid' : ''" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksa_jabatan']">
                                <div class="invalid-feedback">{{ errors['pemeriksaan_' + jenis + '_pemeriksa_jabatan'] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="tab">
                        <div class="table-responsive">
                            <table class="table table-bordered border-dark">
                                <thead>
                                    <tr>
                                        <td rowspan="2" class="align-middle text-center text-dark small fw-bold text-wrap">No</td>
                                        <td rowspan="2" class="align-middle text-center text-dark small fw-bold text-wrap">Komponen Peralatan Alat Berat</td>
                                        <td colspan="4" class="align-middle text-center text-dark small fw-bold">Kondisi Peralatan Alat Berat</td>
                                        <td rowspan="2" class="align-middle text-center text-dark small fw-bold">Keterangan</td>
                                    </tr>
                                    <tr>
                                        <td class="align-middle text-center text-dark small fw-bold">Baik/Ada</td>
                                        <td class="align-middle text-center text-dark small fw-bold">Lengkap</td>
                                        <td class="align-middle text-center text-dark small fw-bold">Tidak Lengkap</td>
                                        <td class="align-middle text-center text-dark small fw-bold">Rusak/Tidak ada</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(komponen, index) in komponens" v-bind:key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ komponen }}</td>
                                        <td>
                                            <div class="form-check d-flex justify-content-center">
                                                <input type="radio" :name="'pemeriksaan_' + jenis + '_pemeriksaan[' + index + ']'" class="form-check-input" value="baik" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksaan'][index]">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-check d-flex justify-content-center">
                                                <input type="radio" :name="'pemeriksaan_' + jenis + '_pemeriksaan[' + index + ']'" class="form-check-input" value="lengkap" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksaan'][index]">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-check d-flex justify-content-center">
                                                <input type="radio" :name="'pemeriksaan_' + jenis + '_pemeriksaan[' + index + ']'" class="form-check-input" value="tidak_lengkap" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksaan'][index]">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-check d-flex justify-content-center">
                                                <input type="radio" :name="'pemeriksaan_' + jenis + '_pemeriksaan[' + index + ']'" class="form-check-input" value="rusak" v-model="this.data['pemeriksaan_' + jenis + '_pemeriksaan'][index]">
                                            </div>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="d-flex justify-content-between">
            <a :href="baseUrl + 'penyewaan/download/' + currentStep + '/' + data.id + '-' + data.hash" target="_blank" class="btn bg-gradient-info" v-if="this.id">Unduh docx</a>
            <div></div>
            <button type="submit" class="btn bg-gradient-success">Simpan</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Pengajuan',
    data() {
        return {
            id: this.$route.params.id,
            baseUrl: process.env.VUE_APP_URL,
            data: {
                pemeriksaan_pengambilan_pemeriksaan: [],
                pemeriksaan_pengembalian_pemeriksaan: []
            },
            alatBerats: {},
            currentStep: 'permohonan',
            steps: ['permohonan', 'ijin_pemakaian', 'perjanjian_sewa', 'pengambilan_alat_berat', 'pengembalian_alat_berat', 'pemeriksaan_alat_berat'],
            komponens: ['Engine / Mesin', 'Kopling', 'Gardan', 'Sterring', 'Rem', 'Kelistrikan', 'Chasis / Body', 'Pompa – pompa', 'Roda', 'Engkol / Slenger', 'Oli mesin', 'Oli gardan', 'Oli transmisi', 'Oli hidrolis', 'Fant belt', 'Slang – slang / Hose', 'Motor travel', 'Control valve', 'Control Unit', 'Monitor'],
            errors: {}
        }
    },
    methods: {
        Store() {
            const self = this;
            if (!this.id) {
                this.axios.post('penyewaan', this.data).then((response) => {
                    if (response.data.error) {
                        this.errors = response.data.message;
                    } else {
                        this.$swal.fire({
                            icon: 'success',
                            title: response.data.message,
                            text: `Berhasil Melakukan Penyewaan`,
                        }).then(function () {
                            self.$router.push({ name: 'auth.guest' });
                        });
                    }
                });
            } else {
                this.axios.put('penyewaan/' + this.id, this.data).then((response) => {
                    if (response.data.error) {
                        this.errors = response.data.message;
                    } else {
                        this.$swal.fire({
                            icon: 'success',
                            title: response.data.message,
                            text: `Sukses Menyimpan Data`,
                        })
                        if (this.steps[this.steps[this.steps.indexOf(this.currentStep) + 1]]) {
                            this.changeStep(this.steps[this.steps.indexOf(this.currentStep) + 1]);
                        }
                    }
                });
            }
        },
        changeStep(step) {
            this.currentStep = step;
        }
    },
    mounted() {
        this.axios.get('alat_berat-list').then((response) => {
            this.alatBerats = response.data;
        });
        if (this.id) {
            this.axios.get('penyewaan/' + this.id).then((response) => {
                this.data = response.data;
                this.data.pemeriksaan_pengambilan_pemeriksaan = JSON.parse(response.data.pemeriksaan_pengambilan_pemeriksaan);
                this.data.pemeriksaan_pengembalian_pemeriksaan = JSON.parse(response.data.pemeriksaan_pengembalian_pemeriksaan);
            });
        }
    }

}
</script>